// Project.js
import React from 'react';
import { Link } from 'react-router-dom';

const Project = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1 className="card-title">You are ahead of your time</h1>
      <p className="card-text">This feature is currently being built with<br />the expertise of a Project Management Professional. <br />Check back again later!<br /><img src="./pmp.png" alt="Project Management Professional" style={{ width: '200px', height: '200px' }} /></p>
      
      <Link to="/">Go back to Home</Link>
    </div>
  );
};

export default Project;
